export const SERVICE_CODE = 'DASHBOARD_CODEV' + '_SERVICE';
